import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {DefaultService} from "../../shared/_services/abstract/default.service";

@Injectable()
export class FinanceService extends DefaultService {

    link: any;
    filters: any = {};

    onProductUpdate: BehaviorSubject<any>;
    onSearchTextChanged: Subject<any>;
    constructor(public override http: HttpClient) {
        super(http);
        this.setResourceLink('stations/user_running_transactions');
        this.onProductUpdate = new BehaviorSubject([]);
        this.onSearchTextChanged = new Subject();

    }


}
